<template>
  <v-container
    id="app-customer"
    pa-0
    pt-2
  >
    <div class="bloc-full-screen pa-1">
      <v-card
        light
        class="px-3 py-2 mb-10"
        style="height: 65vh;"
      >
        <v-radio-group
          v-model="civility"
          row
          hide-details
          class="px-5 mt-1 pb-1"
        >
          <v-radio
            label="Monsieur"
            :value="3"
            class="mr-auto"
            :disabled="fieldsDisabled"
            :readonly="fieldsDisabled"
          />
          <v-radio
            label="Madame"
            :value="2"
            :disabled="fieldsDisabled"
            :readonly="fieldsDisabled"
          />
        </v-radio-group>
        <h3
          v-if="civilityRequired"
          class="error--text absolute-right mr-3"
          style="top: 8px"
        >
          *
        </h3>
        <v-text-field
          v-model="lastname"
          :label="$t('field.customer.name')"
          :prepend-inner-icon="IconEnum.user"
          :disabled="fieldsDisabled"
          hide-details
          class="mb-2 needsclick"
          name="lastname"
        >
          <template
            v-if="nameRequired"
            v-slot:append
          >
            <h3 class="error--text">
              *
            </h3>
          </template>
        </v-text-field>
        <v-text-field
          v-model="firstname"
          :label="$t('field.customer.firstname')"
          :prepend-inner-icon="IconEnum.user"
          :disabled="fieldsDisabled"
          hide-details
          class="mb-2 needsclick"
          name="firstname"
        >
          <template
            v-if="firstnameRequired"
            v-slot:append
          >
            <h3 class="error--text">
              *
            </h3>
          </template>
        </v-text-field>
        <v-text-field
          v-model="mail"
          :label="$t('field.customer.mail')"
          :prepend-inner-icon="IconEnum.mail"
          :disabled="fieldsDisabled"
          :rules="[v => /^[\w-\.\+]+@([\w-]+\.)+[\w-]{2,4}$|^$/.test(v)]"
          hide-details
          class="mb-3 needsclick"
          name="mail"
          type="email"
          @update:error="mailErrorTrigger"
        >
          <template
            v-if="mailRequired"
            v-slot:append
          >
            <h3 class="error--text">
              *
            </h3>
          </template>
        </v-text-field>
        <date-dialog
          v-model="showDateEntry"
          btn-class="right success"
          title-trad="birth_date"
          subtitle-trad="birth_date_selection"
          hide-overlay
          outlined
          :default-date="birthDay ? birthDay : null"
          :min-date="null"
          @del="showDateEntry = false"
          @cancel="showDateEntry = false"
          @valid="validBirthDay"
        />
        <v-text-field
          v-model="birthDay"
          :label="$t('field.customer.birthDay')"
          :prepend-inner-icon="IconEnum.date_field"
          :disabled="fieldsDisabled"
          hide-details
          class="mb-3 needsclick"
          name="birthDay"
          type="date"
          @click="clickBirthDay"
        >
          <template
            v-if="birthDayRequired"
            v-slot:append
          >
            <h3 class="error--text">
              *
            </h3>
          </template>
        </v-text-field>
        <v-phone-input
          v-model="phone"
          class="mb-2 needsclick"
          name="phone"
          :disabled="fieldsDisabled"
          :required="phoneRequired"
        />
        <template v-if="!isNew">
          <div
            v-if="address === null || address === undefined"
            class="text-center"
          >
            <vuetify-google-places
              :label="$t('field.customer.address_search')"
              :prepend-inner-icon="IconEnum.address"
              :disabled="fieldsDisabled"
              api-key="AIzaSyDJ7386KYHozxoBLX5-0nL4d-1Hxs1kwks"
              country="fr"
              name="searchAddress"
              class="needsclick"
              autocomplete="off"
              @placechanged="setAddress"
            />
            <v-btn
              class="mt-3"
              name="setAddress"
              :disabled="fieldsDisabled"
              @click="address = {
                AdresseA: '',
                AdresseB: '',
                CodePostal: '',
                Ville: '',
                Pays: 'France'
              }"
            >
              {{ $t('field.customer.address_capture') }}
            </v-btn>
          </div>
          <div
            v-else
            class="pa-1 pb-2 mt-3 elevation-3"
          >
            <v-btn
              class="btn"
              style="z-index:9"
              absolute
              right
              icon
              :disabled="fieldsDisabled"
              @click="resetAddress"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-text-field
              v-model="address.AdresseA"
              :label="$t('field.customer.address')"
              :disabled="fieldsDisabled"
              hide-details
              name="address"
              class="needsclick"
            />
            <v-text-field
              v-model="address.AdresseB"
              :label="$t('field.customer.address_comp')"
              :disabled="fieldsDisabled"
              hide-details
              class="mb-2 needsclick"
              name="complement"
            />
            <div class="d-flex">
              <v-text-field
                v-model="address.CodePostal"
                :label="$t('field.customer.cp')"
                :disabled="fieldsDisabled"
                hide-details
                style="width:40%"
                class="mr-2 needsclick"
                name="postalcode"
                type="number"
                inputmode="decimal"
                maxlength="5"
              />
              <v-text-field
                v-model="address.Ville"
                :label="$t('field.customer.city')"
                :disabled="fieldsDisabled"
                hide-details
                name="city"
                class="needsclick"
              />
            </div>
          </div>
        </template>
      </v-card>
    </div>

    <bottom-action
      btn-valid
      btn-del
      btn-cancel-disabled
      :btn-valid-disabled="disabled"
      @valid="isNew ? create() : edit()"
      @del="del"
      @cancel="cancel"
    />
  </v-container>
</template>

<script>
import { $alert } from '@/modules/Utils'
import { Carrier } from '@/modules/Carrier'
import { Scan } from '@/modules/Scan'
import {ActionEnum, EnumModeCashiers, IconEnum} from '@/modules/Enums'

import { VuetifyGooglePlaces } from 'vue-google-places'
import VPhoneInput from '@/components/input/VPhoneInput'
import DateDialog from '@/components/modal/DateDialog'

export default {
  name: 'Customer',

  components: {
    DateDialog,
    VPhoneInput,
    VuetifyGooglePlaces
  },

  props: {
    customers: { type: Array, default: null },
    customer: { type: Object, default: null },
    badge: { type: Object, default: null },
    tickets: { type: Array, default: null }
  },

  data () {
    return {
      IconEnum,
      //
      civility: null,
      lastname: '',
      firstname: '',
      mail: '',
      birthDay: '',
      showDateEntry: false,
      phone: this.customer ? this.customer.Telephone ? this.customer.Telephone : (this.customer.Mobile ? this.customer.Mobile : '') : '',
      address: null,
      mailError: false,
      customerPhone: null
    }
  },

  computed: {
    fromInfoBadgeView () { return this.badge !== null },
    fromTicketView () { return this.tickets !== null },
    fromCustomerResearch () { return this.customers !== null },
    //
    creationContactMyTerminal() {
      return this.$store.getters.creationContactMyTerminal
    },
    isNew () {
      return this.customer === null
    },
    disabled () {
      const requiredField =  (this.civilityRequired && this.civility === null) ||
        (this.nameRequired && this.lastname === '') ||
        (this.firstnameRequired && this.firstname === '') ||
        (this.mailRequired && (this.mail === '' || this.mailError)) ||
        (this.birthDayRequired && this.birthDay === '') ||
        (this.phoneRequired && this.phone === '') ||
        (this.addressRequired && this.address === null || (
          this.addressRequired && this.address !== null && (
            this.address.AdresseA === '' || this.address.CodePostal === '' || this.address.Ville === ''
          )
        ))
      return (
        (!this.isNew && (
          requiredField || (
            this.civility === this.customer.Civilite &&
            this.lastname === this.customer.Nom &&
            this.firstname === this.customer.Prenom &&
            (this.mail === this.customer.Mail || this.mailError) &&
            (this.phone === this.customerPhone || this.phone === null) &&
            (this.birthDay === this.customer.DateNaissance) &&
            (this.address === this.customer.Adresse || (
              this.address !== null && (this.address.AdresseA === '' || this.address.CodePostal === '' || this.address.Ville === '')
            ))
          ))
        )|| (
        this.isNew && requiredField
      )
      )
    },
    fieldsDisabled () {
      return this.customer !== null && (this.customer.MailStatut === 1 || this.customer.MailStatut === 2)
    },
    civilityRequired () { return this.creationContactMyTerminal.includes('civility') },
    nameRequired () { return this.creationContactMyTerminal.includes('name') },
    firstnameRequired () { return this.creationContactMyTerminal.includes('firstname') },
    mailRequired () { return this.creationContactMyTerminal.includes('mail') },
    birthDayRequired () { return this.creationContactMyTerminal.includes('birthday') },
    phoneRequired () { return this.creationContactMyTerminal.includes('phone') },
    addressRequired () { return this.creationContactMyTerminal.includes('address') }
  },

  beforeMount () {
    this.$emit('title', this.$i18n.t('title.client_edit'))
  },

  mounted () {
    this.$emit('title', this.$i18n.t('title.client_edit'))
    // Remove default placeholder of google place input
    if (this.customer !== null && this.customer.Adresse === null) {
      this.resetAddress()
    }

    if (this.customer !== null) {
      this.customerPhone = this.customer ? this.customer.Telephone ? this.customer.Telephone : (this.customer.Mobile ? this.customer.Mobile : '') : ''
      this.civility = this.customer.Civilite
      this.lastname = this.customer.Nom
      this.firstname = this.customer.Prenom
      this.mail = this.customer.Mail
      this.birthDay = this.customer.DateNaissance
      this.phone = this.customerPhone
      this.address = this.customer.Adresse
    } else if (this.creationContactMyTerminal.length === 0) {
      // Si on a pas le droit de création, on retourne à l'accueil
      this.$router.replace('/')
    }
  },

  methods: {
    del (customer = this.customer) {
      if (this.fromInfoBadgeView) {
        this.$router.replace({
          name: 'info-badge',
          params: { badge: this.badge, carrier: customer, customers: this.customers }
        })
      } else if (this.fromTicketView) {
        let floatingMode = false;
        if (this.$store.state.teleparameters.CashierEngagementMode) {
          floatingMode = this.$store.state.teleparameters.CashierEngagementMode === EnumModeCashiers.FLOATING;
        }
        this.$router.replace({
          name: 'ticket',
          params: { carrier: customer, tickets: this.tickets, floatingModeEnabled : floatingMode }
        })
      } else if (this.fromCustomerResearch) {
        this.$router.replace({
          name: 'customer-search',
          params: { customers: this.customer }
        })
      } else {
        this.cancel()
      }
    },
    cancel () {
      this.$router.replace('/home')
    },
    //
    contactFormatted (contactId) {
      return {
        IDContact: contactId,
        Civilite: this.civility,
        Nom: this.lastname,
        Prenom: this.firstname,
        Mail: this.mail,
        DateNaissance: this.birthDay,
        Mobile: this.phone,
        Adresse: this.address
      }
    },
    mailErrorTrigger (value) {
      this.mailError = value;
    },
    resetAddress () {
      this.address = null
      setTimeout(() => {
        // Remove default placeholder of google place input
        document.getElementsByName('searchAddress')[1].setAttribute('placeholder', '')
      }, 200)
    },
    setAddress (e) {
      if (e) {
        this.address = {
          AdresseA: e.name,
          AdresseB: '',
          CodePostal: e.postal_code,
          Ville: e.locality,
          Pays: e.country,
        }
      } else {
        this.address = null
      }
    },
    edit () {
      let civility = (this.customer && this.customer.Civilite !== this.civility) ? this.civility : null
      let lastname = (this.customer && this.customer.Nom !== this.lastname) ? this.lastname : null
      let firstname = (this.customer && this.customer.Prenom !== this.firstname) ? this.firstname : null

      let mail = null
      if (!this.mailError && (this.customer && this.customer.Mail !== this.mail)) {
        mail = this.createMail()
      }

      let birthDay = (this.customer && this.customer.DateNaissance !== this.birthDay) ? this.birthDay : null
      let phone = null
      if (this.customer && this.customerPhone !== this.phone) {
        phone = this.createPhone()
      }

      let address = null
      if (
        this.address !== null && this.address !== this.customer.Adresse &&
        this.address.AdresseA !== '' && this.address.CodePostal !== '' && this.address.Ville !== ''
      ) {
        if (this.address.AdresseB === '') {
          delete this.address.AdresseB
        }
        address = [{
          Tag: 'MYTM',
          ...this.address,
          default: 1
        }]
      }

      if ((this.address === null || this.address.AdresseA === '') && this.address !== this.customer.Adresse) {
        address = [];
      }

      Carrier.setContact(
        (response) => {
          $alert(this.$i18n.t('success.contact_updated'), 'success')
          this.del(this.contactFormatted(response.IDContact))
        },
        (error) => {
          $alert(error)
        },
        this.customer.IDContact,
        this.badge ? this.badge.IDBadge : null,
        lastname,
        firstname,
        mail,
        phone,
        address,
        civility,
        null,
        birthDay
      )
    },
    create () {
      let civility = this.civility !== null ? this.civility : null
      let lastname = this.lastname !== '' ? this.lastname : null
      let firstname = this.firstname !== '' ? this.firstname : null

      let birthDay = this.birthDay !== '' ? this.birthDay : null
      let mail = (!this.mailError && this.mail !== '') ? this.createMail() : null

      let phone = (this.phone !== null || this.phone !== '') ? this.createPhone() : null

      Carrier.setContact(
        (response) => {
          if (response.Existe) {
            this.$store.commit('loader', false)

            if (this.$store.state.amount > 0) {
              $alert(
                `Le contact ${response.Nom} ${response.Prenom} existe déjà avec la carte N° ${response.NumeroCarte}.`,
                'info',
                'Souhaitez-vous continuer l\'achat ?',
                -1,
                [{
                  title: 'Continuer l\'achat',
                  color: 'success',
                  click: () => { this.startScan(response.NumeroLong) }
                },{
                  title: 'Retour',
                  color: 'info'
                }],
                null,
                false
              )
            } else {
              $alert('Ce contact existe déjà')
            }

            return
          }

          if (response.EstCollectionneur) {
            this.$store.commit('qrCodeUrl', {
              code: response.NumeroLong,
              text: 'Teritoria',
              textSup: 'votre carte de fidélité',
              textRes: 'N° ' + response.NumeroCarte
            })
          } else if (response.Url) {
            this.$store.commit('qrCodeUrl', {
              code: response.url,
              text: 'Scannez ce QRCode pour',
              textSup: 'terminer votre inscription',
              textRes: ''
            })
          }

          if (this.$store.state.amount > 0) {
            this.startScan(response.NumeroLong)
          } else {
            let floatingMode = false;
            if (this.$store.state.mode) {
              floatingMode = this.$store.state.mode === EnumModeCashiers.FLOATING;
            }
            this.$router.replace({
              name: 'ticket',
              params: { floatingModeEnabled : floatingMode }
            })
          }
        },
        (error) => {
          $alert(error)
        },
        null,
        null,
        lastname,
        firstname,
        mail,
        phone,
        null,
        civility,
        null,
        birthDay,
        null,
        false
      )
    },
    startScan (numLong) {
      Scan.badge(
        numLong,
        ActionEnum.loyalty,
        'P',
        () => {
        },
        (error) => {
          $alert(error)
        }
      )
    },
    validBirthDay (date) {
      this.birthDay = date
      this.showDateEntry = false
    },
    clickBirthDay (event) {
      event.preventDefault()
      this.showDateEntry = true
    },
    createPhone () {
      if (this.phone === null || this.phone === '') {
        return [];
      } else {
        let nb = null
        if (this.phone[0] === '+') {
          nb = this.phone.split(' ')
          nb = '0' + nb[1]
        } else {
          nb = this.phone.substring(0, 2)
        }
        let isMobileNumber = (nb === '06' || nb === '07')

        return [{
          Tag: 'MYTM',
          Telephone: this.phone,
          default: 1,
          IDTypeTelephone: isMobileNumber ? 3 : 1
        }]
      }
    },
    createMail () {
      if (this.mail === null || this.mail === '') {
        return [];
      } else {
        return [{
          Tag: 'MYTM',
          Email: this.mail.trim().toLowerCase(),
          default: 1
        }]
      }
    }
  }
}
</script>
